import { ActivatedRoute, Params } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HasPageTitleAndMetaData, StaticPageInterface } from '@app/interfaces/_index';
import { Meta, Title } from '@angular/platform-browser';

import { AnnouncementService } from '@app/services/_index';
import { StaticPage } from '@app/models/_index';
import { StaticPageAdapter } from '@app/adapters/_index';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
  standalone: false,
})
export class AnnouncementComponent implements OnInit, OnDestroy, HasPageTitleAndMetaData {
  // Page Properties
  announcement: StaticPage;
  subs: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private announcementService: AnnouncementService,
    private titleService: Title,
    private metaService: Meta,
    private staticPageAdapter: StaticPageAdapter
  ) {}

  /**
   * On Init, call getCertification to load data
   */
  ngOnInit(): void {
    // Calling the Title and Meta tag.
    this.setTitleAndMetaData();
    this.subs.push(
      this.route.params.subscribe((params: Params) => {
        // Pull Certification Content based on Slug selected.
        this.getAnnouncementBySlug(params);
      })
    );
  }

  /**
   * Get Certification Announcement Content by slug
   * @param params indicates value for each slug selected
   */
  getAnnouncementBySlug(params: any): void {
    // TODO: Need to add loading mask
    this.subs.push(
      this.announcementService.getAnnouncementContent().subscribe({
        next: (response: StaticPageInterface[]) => {
          if (response && response.length > 0) {
            response.filter((item: StaticPageInterface) => {
              if (item.slug === params.slug) {
                this.announcement = this.staticPageAdapter.adapt(item);
              }
            });
          }
        },
        error: (error) => {
          console.log(error);
        },
        complete: () => {
          // Force is loading to stop and complete in case of any unhandled errors
          console.log('Announcement content completed');
        },
      })
    );
  }

  /**
   * Set selected Certification Announcement title and metadata tags
   */
  setTitleAndMetaData(): void {
    // NOTE: Update page title on certification announcement page
    this.titleService.setTitle('Certifications Announcement | Genesys Beyond');
    // NOTE: Update meta tag description for page
    this.metaService.updateTag({
      name: 'description',
      content:
        'See all of your Genesys Beyond enrollments, certifications, and recommended learning in one place.',
    });
  }

  /**
   * On Destroy unsubscribe the services to prevent memory leaks
   */
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
